import { Component } from '@angular/core';

@Component({
    selector: 'payments-loading-section',
    templateUrl: './loading-section.component.html',
    styleUrls: ['./loading-section.component.scss'],
    standalone: false
})
export class LoadingSectionComponent {}
